import * as qiniu from 'qiniu-js'

const putbFile = (file, key, auth) => {
  return new Promise((resolve, reject) => {
    const observable = qiniu.upload(file, key, auth, {}, {})
    console.log('observable', observable)
    const subscription = observable.subscribe({
      next(res) {
      },
      error(err) {
        reject(err)
      },
      complete(res) {
        resolve(res)
      }
    })
  })
}


export {
  putbFile,
}